import { useGetReportOfSaleVersionsQuery } from '../../../../services/api/report-of-sale';
import ReportOfSaleSection from './ReportOfSaleSection';

const TITLES: Record<string, string> = {
  admin: 'Admin Report of Sale',
  buyer: 'Buyer Report of Sale',
  seller: 'Seller Report of Sale'
};
const ORDER: Array<'admin' | 'buyer' | 'seller'> = ['admin', 'buyer', 'seller'];

const ReportOfSaleVersions = ({ vehicleId, infoBlock }: { vehicleId: number; infoBlock?: boolean }) => {
  const { data } = useGetReportOfSaleVersionsQuery({ vehicleId });

  if (!data) return null;

  const sections = ORDER.filter(type => data[type]?.length);
  if (sections.length === 0) return null;

  return (
    <>
      {sections.map(type => (
        <ReportOfSaleSection
          key={type}
          vehicleId={vehicleId}
          reportType={type}
          title={TITLES[type]}
          versions={data[type] || []}
          infoBlock={infoBlock}
        />
      ))}
    </>
  );
};

export default ReportOfSaleVersions;
